export default function Footer() {
    return (
        <footer
            data-testid="landing-footer"
            className="rule-top bg-[#050505]"
        >
            <div className="container-x py-14 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-start">
                <div className="md:col-span-6">
                    <div className="flex items-center gap-2 mb-4">
                        <span className="w-2 h-2 bg-[#e84125] block" />
                        <span className="font-mono uppercase text-[0.68rem] tracking-[0.24em] text-white/80">
                            Viral Digital Labs
                        </span>
                    </div>
                    <p className="font-editorial italic text-white/60 text-2xl md:text-3xl max-w-[26ch] leading-tight">
                        Two engines. One revenue system.
                    </p>
                </div>
                <div className="md:col-span-3 flex flex-col gap-2 font-mono uppercase text-[0.68rem] tracking-[0.22em] text-white/50">
                    <a
                        href="#manifesto"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        Manifesto
                    </a>
                    <a
                        href="#playbook"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        Playbook
                    </a>
                    <a
                        href="#pricing"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        Pricing
                    </a>
                    <a
                        href="#faq"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        FAQ
                    </a>
                </div>
                <div className="md:col-span-3 flex flex-col gap-2 font-mono uppercase text-[0.68rem] tracking-[0.22em] text-white/50">
                    <a
                        href="https://www.viraldigitallabs.in"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        viraldigitallabs.in ↗
                    </a>
                    <a
                        href="mailto:hello@viraldigitallabs.in"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        hello@viraldigitallabs.in
                    </a>
                    <a
                        href="https://wa.me/919818116918"
                        target="_blank"
                        rel="noreferrer"
                        className="hover:text-[#e84125] transition-colors"
                    >
                        WhatsApp us ↗
                    </a>
                </div>
            </div>
            <div className="container-x pb-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 font-mono uppercase text-[0.62rem] tracking-[0.22em] text-white/30">
                <span>© {new Date().getFullYear()} Viral Digital Labs</span>
                <span>
                    Landing page · Dual-Engine Advantage · Handcrafted in New
                    Delhi
                </span>
            </div>
        </footer>
    );
}
